import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../pages/LoginPage";
import { Dashboard } from "../pages/DashboardPage";
import { PrivateRoutes } from "./PrivateRoutes";
import { RoleRoute } from "./RoleRoute";
import { LoginRoute } from "./LoginRoute";
import { Layout } from "@/components/Layout";
import { ClientsPage } from "@/pages/client/ClientsPage";
import { ClientDetailPage } from "@/pages/client/ClientDetailPage";
import { UsersPage } from "@/pages/user/UserPage";
import { CompaniesPage } from "@/pages/company/CompaniesPage";
import { ResetPassword } from "@/pages/ResetPassword";
import { LogsPage } from "@/pages/LogsPage";
import { ConfigPage } from "@/pages/config/ConfigPage";
import { ModulePage } from "@/pages/module/ModulePage";
import { ModulesPage } from "@/pages/module/ModulesPage";
import { ModuleUsersPage } from "@/pages/module/ModuleUsersPage";
import ConnectionAgentPage from "@/pages/AgenteConexaoPage";
import { UserRoles } from "@/api/user.service";
import { FlashPage } from "@/pages/panel/FlashPage";
import { ConsultaProdutoPage } from "@/pages/panel/ConsultaProdutoPage";
import { MetasPage } from "@/pages/panel/MetasPage";
import { EscalaPage } from "@/pages/panel/EscalaPage";
import { RupturaPage } from "@/pages/panel/RupturaPage";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<LoginRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="/resetar-senha" element={<ResetPassword />} />

        {/* Private Routes Wrapper */}
        <Route element={<PrivateRoutes />}>
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />

            <Route element={<RoleRoute allowedRoles={[UserRoles.Admin]} />}>
              <Route path="/clientes" element={<ClientsPage />} />
              <Route path="/clientes/:clientId/agendamentos" element={<ClientDetailPage />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/uso-app" element={<Navigate to="/logs?visao=uso" replace />} />
              <Route path="/empresas/:clientId" element={<CompaniesPage />} />
            </Route>

            <Route path="/painel/consulta-de-produto" element={<ConsultaProdutoPage />} />
            <Route path="/painel/metas" element={<MetasPage />} />
            <Route path="/painel/escala" element={<EscalaPage />} />
            <Route path="/painel/gestao-ruptura" element={<RupturaPage />} />
            <Route path="/painel/:moduleId" element={<FlashPage />} />

            {/* "Editar perfil" navega pra cá pra qualquer cargo, inclusive Operador */}
            <Route path="/usuarios" element={<UsersPage />} />

            {/* Operadores só têm acesso à visão de módulos (dashboard + painel) */}
            <Route element={<RoleRoute allowedRoles={[UserRoles.Admin, UserRoles.Cliente]} />}>
              <Route path="/modulos/:userId" element={<ModulePage />} />
              <Route path="/modulos/:moduleId/usuarios" element={<ModuleUsersPage />} />
              <Route path="/modulos" element={<ModulesPage />} />
              <Route path="/resetarSenha/:clientId" element={<ResetPassword />} />
              <Route path="/agente-conexao" element={<ConnectionAgentPage />} />
              <Route path="/configuracoes" element={<ConfigPage />} />
            </Route>
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};